/* Formatting helpers: Italian locale because the firm is Italian. */
export const EUR = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (Number.isNaN(n)) return "—";
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 2,
  }).format(n);
};

export const num = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const n = typeof value === "string" ? parseFloat(value) : value;
  return Number.isNaN(n) ? 0 : n;
};

export const fmtDate = (value) => {
  if (!value) return "—";
  const d = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(d.getTime())) return "—";
  // Italian compact format: "05 gen 2026" (no trailing dot on month abbr).
  return new Intl.DateTimeFormat("it-IT", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
    .format(d)
    .replace(".", "");
};

export const fmtMonth = (year, month) => {
  const d = new Date(Number(year), Number(month) - 1, 1);
  return new Intl.DateTimeFormat("it-IT", { month: "short", year: "2-digit" })
    .format(d)
    .replace(".", "");
};

export const todayISO = () => {
  const d = new Date();
  return d.toISOString().slice(0, 10);
};

export const monthRange = (year) => ({
  date_from: `${year}-01-01`,
  date_to: `${year}-12-31`,
});

export const statusIT = {
  planned: "In programma",
  partially_paid: "Parziale",
  paid: "Pagato",
  skipped: "Saltato",
  cancelled: "Annullato",
  not_due: "Non dovuta",
};

export const recurrenceIT = {
  one_time: "Una tantum",
  monthly: "Mensile",
  bi_monthly: "Bimestrale",
  quarterly: "Trimestrale",
  every_4_months: "Quadrimestrale",
  semi_annual: "Semestrale",
  annual: "Annuale",
  custom_plan: "Piano rateale",
};

/** Build a YYYY-MM-DD string from local-time components.
 *  Avoids the off-by-one bug of `new Date(...).toISOString().slice(0,10)`,
 *  which shifts to UTC and can flip the date in non-UTC timezones. */
export const isoLocalDate = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

/** Returns [firstISO, lastISO] for the calendar month containing the supplied
 *  Date — month-end is always the real last day (28/29/30/31 as appropriate). */
export const monthBounds = (d = new Date()) => {
  const y = d.getFullYear();
  const m = d.getMonth(); // 0-indexed
  const first = `${y}-${String(m + 1).padStart(2, "0")}-01`;
  const last = isoLocalDate(new Date(y, m + 1, 0));
  return [first, last];
};

/** Returns [firstISO, lastISO] for the calendar quarter containing the date.
 *  Q1: Jan-Mar, Q2: Apr-Jun, Q3: Jul-Sep, Q4: Oct-Dec. */
export const quarterBounds = (d = new Date()) => {
  const y = d.getFullYear();
  const qStartMonth = Math.floor(d.getMonth() / 3) * 3; // 0,3,6,9
  const first = `${y}-${String(qStartMonth + 1).padStart(2, "0")}-01`;
  const last = isoLocalDate(new Date(y, qStartMonth + 3, 0));
  return [first, last];
};

/** Returns [firstISO, lastISO] for the calendar semester containing the date.
 *  H1: Jan-Jun, H2: Jul-Dec. */
export const semesterBounds = (d = new Date()) => {
  const y = d.getFullYear();
  const sStartMonth = d.getMonth() < 6 ? 0 : 6;
  const first = `${y}-${String(sStartMonth + 1).padStart(2, "0")}-01`;
  const last = isoLocalDate(new Date(y, sStartMonth + 6, 0));
  return [first, last];
};

/** Returns [firstISO, lastISO] for the calendar year containing the date. */
export const yearBounds = (d = new Date()) => {
  const y = d.getFullYear();
  return [`${y}-01-01`, `${y}-12-31`];
};

/**
 * Operational payment method labels.
 * The backend enum has 5 values; the UI surfaces only the 4 operational ones
 * the studio uses, plus a synthetic "unspecified" bucket for legacy payments
 * registered before the field was required.
 */
export const paymentMethodIT = {
  bank_transfer: "Banca",
  cash: "Contanti",
  card: "POS",
  other: "Altro",
  direct_debit: "Banca",
  unspecified: "Non specificato",
};

/** Options shown in the "Registra pagamento" form (in operational order). */
export const paymentMethodOptions = [
  { value: "bank_transfer", label: "Banca" },
  { value: "cash", label: "Contanti" },
  { value: "card", label: "POS" },
  { value: "other", label: "Altro" },
];
